module.exports = {"data":[{"national":"宁夏统计年鉴"},{"NumData":"平罗县统计公报和宁夏统计年鉴"},{"NumGovernment":"平罗县审批服务管理局"},{"promotionalVideo":"平罗县融媒体中心","weather":"天气网"},{"lang":"平罗县农村综合改革服务中心","price":"惠农网","quality":"平罗县农产品质量溯源监管平台","qualityTwo":"平罗县投入品在线监管云服务平台","production":"农业农村局农业技术推广服务中心","farming":"数据填报系统"},{"farming_input":"平罗县投入品云服务平台","implements":"农机精准作业协同支撑平台"}]}


//////////////////
// WEBPACK FOOTER
// ./static/dataSources/sources.json
// module id = ne4j
// module chunks = 1